import { useEffect, useRef, type MutableRefObject } from 'react';

/** Keeps a ref in sync with the latest value so once-registered handlers (sockets, timers) never close over a stale value. */
export function useLatest<T>(value: T): MutableRefObject<T> {
  const ref = useRef(value);
  useEffect(() => {
    ref.current = value;
  }, [value]);
  return ref;
}
